import React, { cloneElement, Fragment, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { eraseStroke } from "../../../../utils/erase";
import { setQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";

let canvas = null;
function ScribbleErase(props) {

  const dispatch = useDispatch();

  const [isDrawing, setDrawing] = useState(false);
  const questionView = useSelector(state => state.questionView);
  const setQuestionView = payload => { dispatch(setQuestionViewAction(payload)) };

  useEffect(() => {
    canvas = { ...questionView };
  }, [questionView]);

  useEffect(() => {
    let isComponentMounted = true
    const dom = document.getElementById('learning_picture');

    dom.addEventListener('touchstart', (e) => {
      if (isComponentMounted) setDrawing(true);
    });

    window.addEventListener('touchend', e => {
      if (isDrawing === true) {
        if (isComponentMounted) setDrawing(false);

        const dom = document.getElementById('learning_picture');
        if (dom) {
          dom.removeEventListener("touchmove", eraseEvent)
          dom.removeEventListener("click", eraseEvent)
        }
      }
    });

    return () => {
      isComponentMounted = false;
    }
  }, [canvas, isDrawing, questionView.isErase]);

  useEffect(() => {
    if (!questionView.isErase) return;
    if (!isDrawing) return;

    const dom = document.getElementById('learning_picture');
    dom.addEventListener("touchmove", eraseEvent);
    dom.addEventListener("click", eraseEvent);

  }, [questionView.isErase, isDrawing, canvas]);

  const eraseEvent = (e) => {
    if (isDrawing) eraseStroke(e, canvas.scribbleCanvasDraw, 'learning_picture');
  };

  const handleUndoClick = () => {
    canvas.scribbleCanvasDraw.undo();
  }

  const handleEraseClick = useCallback((bool) => {
    setQuestionView({ isErase: bool });
  }, [questionView.isErase]);

  return cloneElement(props.children || <Fragment />, {
    handleEraseClick: handleEraseClick,
    handleUndoClick: handleUndoClick
  });
}

export default ScribbleErase;